import { Location, Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { FeatureIdEnum } from '../enums';

import { ContextState, FeaturesTree, GuardClass, GuardResolveFunction } from '../models';

import { APP_CONSTS } from '../store/app/app.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

import { FeaturesTreeUtils } from '../utils';

export class InsightsLandingGuard extends GuardClass {

  public static execute(to: Route, from: Route, next: GuardResolveFunction): void {
    let redirectLocation: Location;
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    const featuresTree: FeaturesTree = store.getters[`${ APP_CONSTS.moduleName }/${ APP_CONSTS.getters.featuresTree }`];
    const context: ContextState = store.getters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const featureNode = FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.INSIGHTS, featuresTree[context.domain]);
    if (featureNode.children.length === 1) {
      redirectLocation = {
        ...to,
        name: featureNode.children[0].routeName
      };
    }
    if (!!redirectLocation) {
      redirectLocation.replace = true;
    }
    next(redirectLocation);
  }

}
